module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_1-1aafd5d1a6ef2521a98e0c159383f783.png";